import React from 'react';
import { parsePrice, isAvailableNow } from '../../../../lib/helper.js';
import { get, toNumber } from 'lodash';
import {
  enforceForceModifierCount,
  getEnforcedModifierCount,
} from '../../actions/cartActions.js';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import defaultMsg from '../../../../translations/lang/en-US.json';
import { MODIFIER_DETOR, MODIFIER_FORCED } from '../../../../util/Constants';

class Modifier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userToggled: false,
    };
    this.getOptions = this.getOptions.bind(this);
    this.renderModifiersList = this.renderModifiersList.bind(this);
  }

  parseModifierCost = cost => {
    if (cost && cost.toString().replace(/[0\.,\t\s]/g, '').length > 0) {
      cost = parsePrice(cost);
      return (
        <strong title={cost + ' will be added to item price.'}>
          {` (+ ${cost})`}
        </strong>
      );
    } else {
      return null;
    }
  };
  onChange = e => {
    !this.state.userToggled &&
      this.setState({
        userToggled: true,
      });
    const mStatus = enforceForceModifierCount(
      this.props.modifier['type_option'],
      this.props.modifier.option
    );
    if (mStatus.count > 1) {
      const selectedCount = get(this.props, 'modifier.option', []).reduce(
        (agg, val) => (val.isChecked ? agg + 1 : agg),
        0
      );
      if (e.target.checked && selectedCount >= mStatus.count) {
        // Ignore this checkbox.
        e.target.checked = false;
        return;
      }
    }

    this.props.handleModifierChange(e);
  };
  getType() {
    const modifierType = get(this.props, 'modifier.type', 'checklist');
    const typeOption = get(this.props, 'modifier.type_option', '');
    const isOptional = this.props.type === 'optional';

    return getEnforcedModifierCount(typeOption) === 1
      ? 'radio'
      : modifierType === 'choice' && !isOptional
        ? 'radio'
        : 'checkbox';
  }
  getOptions() {
    const modifierList = get(this.props, 'modifier.option', []);

    const type = this.getType();
    return modifierList.map(item => {
      return !item.title.replace(/\s/g, '').length ? null : (
        <RTDModifier
          onChange={this.onChange}
          type={type}
          modifierType={this.props.type}
          item={item}
          key={item.modifierPath}
          parseModifierCost={this.parseModifierCost}
        />
      );
    });
  }
  componentDidMount() {
    setTimeout(() => {
      this.props.autoFocus &&
        this.getType() === 'radio' &&
        this.ref &&
        this.ref.scrollIntoView({
          behavior: 'smooth',
        });
    }, 0);
  }
  setRef = ref => {
    this.ref = ref;
  };
  renderModifiersList() {
    const modifierOptions = this.getOptions();
    const modifierName = get(this.props, 'modifier.caption', '');
    const typeOption = toNumber(get(this.props, 'modifier.type_option', ''));
    const containerClasses =
      this.props.mobile === true
        ? 'col-md-12 col-xs-12 col-lg-12 col-sm-12 mobile-modifier-container'
        : 'col-lg-12 col-md-6 col-xs-12 col-sm-6';
    const mStatus = enforceForceModifierCount(
      typeOption,
      this.props.modifier.option
    );
    const isValid = mStatus.count === mStatus.selected;
    return (
      <div className={containerClasses} ref={this.setRef}>
        <div className="d-flex d-align-items-center modifierTitle bold">
          {modifierName.toUpperCase()}
        </div>
        {mStatus.count > 1 && (
          <div className="text-muted mv-1" style={{ fontSize: 10 }}>
            (Choose {mStatus.count})
          </div>
        )}
        {modifierOptions}
      </div>
    );
  }

  render() {
    return !this.props.modifier ? null : this.renderModifiersList();
  }
}

const mapStateToProps = (state, { modifierType, ...ownProps }) => {
  const modType =
    modifierType === MODIFIER_FORCED || modifierType === MODIFIER_DETOR
      ? 'forced_modifier'
      : 'modifier';
  const unavailableUntil = state.rtd.status[modType][ownProps.item.id];

  return {
    unavailableUntil,
  };
};
const RTDModifier = connect(mapStateToProps)(
  class extends React.Component {
    componentDidMount() {
      this.scheduleUpdate();
    }
    componentDidUpdate() {
      this.scheduleUpdate();
    }
    componentWillUnmount() {
      this.schedule && clearTimeout(this.schedule);
    }
    scheduleUpdate = () => {
      const unavailableUntil = this.getUnavailableUntil() * 1000;
      const currentTime = new Date().getTime();
      const diff = unavailableUntil - currentTime;
      if (diff > 0) {
        this.schedule && clearTimeout(this.schedule);
        this.schedule = setTimeout(() => {
          // rerender UI.
          this.forceUpdate();
        }, diff + 1);
      }
    };
    getUnavailableUntil = () => {
      const { unavailableUntil, item } = this.props;
      if (unavailableUntil === undefined) {
        return +item.unavailable_until;
      }
      return unavailableUntil;
    };
    render() {
      const { item, type, parseModifierCost, onChange } = this.props;
      const active = isAvailableNow(this.getUnavailableUntil());
      return (
        <div key={item.modifierPath} className="pickupTimeOption">
          <input
            id={item.modifierPath}
            type={type}
            name={item.group}
            value={item.id}
            onChange={onChange}
            disabled={!active}
            className="pickupTimeRadio"
            defaultChecked={item.status === 'defaultChecked' || item.isChecked}
          />
          <label
            htmlFor={item.modifierPath}
            style={{ color: !active && '#CCC' }}
          >
            <span>
              <span />
            </span>
            {item.title}
            {parseModifierCost(item.cost)}
            {!active && (
              <div
                className="label label-danger"
                style={{ display: 'inline', marginLeft: 10 }}
              >
                <FormattedMessage
                  id="itemOutOfStock"
                  defaultMessage={defaultMsg.itemOutOfStock}
                />
              </div>
            )}
          </label>
        </div>
      );
    }
  }
);

export default Modifier;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Modifier.jsx